import videojs from 'video.js';

// Get the Component base class from Video.js
var Button = videojs.getComponent('Button');

// Default options for the plugin.
const defaults = {
  sponsoredUrl: 'https://semanticweapons.com',
};

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var PoweredBy = videojs.extend(Button, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    Button.call(this, player, options);

    this.options = videojs.mergeOptions(defaults, options);

    this.addClass('vjs-button-powered-by');
    this.addClass('vjs-icon-circle');

    this.player().ready(() => {
      this.controlText('Patrocinado por ' + this.options.sponsor);
    });
  },

  handleClick(event) {
    window.open(this.options.sponsoredUrl + '?utm_medium=web&utm_source=d-ns+web+share&utm_campaign=Calistenia+101', '_blank');
  },

});

PoweredBy.prototype.controlText_ = 'Patrocinado por...';

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('PoweredBy', PoweredBy);

export default PoweredBy;
